import { Pivot } from '@h2oai/ui-kit';

import { useTimeFilters } from './common/hooks';
import GPTeOverallData from './components/H2OGPTe/GPTeOverallData/GPTeOverallData';
import GPTeTokenData from './components/H2OGPTe/GPTeTokenData/GPTeTokenData';
import { filterStyles } from './components/H2OGPTe/H2OGPTe.styles';
import TimeFilters from './components/TimeFilters/TimeFilters';
import PageWrapper from './PageWrapper';

export default function H2OGPTe() {
  const { startDate, endDate, selectedTimeFrame, handleTimeFilterChange } = useTimeFilters();

  return (
    <PageWrapper>
      <TimeFilters
        styles={filterStyles()}
        startDate={startDate}
        endDate={endDate}
        selectedTimeFrame={selectedTimeFrame}
        onChange={handleTimeFilterChange}
      />

      <Pivot
        items={[
          {
            content: <GPTeTokenData startDate={startDate} endDate={endDate} />,
            headerText: 'Summary',
          },
          {
            content: <GPTeOverallData startDate={startDate} endDate={endDate} />,
            headerText: 'Events',
          },
        ]}
      />
    </PageWrapper>
  );
}
